'use client';

import { use, useState } from 'react';

import {
  GrassHeader as GrassHeaderFeature,
  GrassInfoModal,
} from '@/features/NewLanding';
import { useDeviceCheck } from '@/shared/hooks';
import { GrassWidgetProps } from '@/shared/types';

const GrassHeader = ({ grassListPromise }: GrassWidgetProps) => {
  const { isDesktop } = useDeviceCheck();
  const [isInfoModalOpen, setIsInfoModalOpen] = useState(false);
  const { grassCount } = use(grassListPromise);

  const openInfoModal = () => {
    setIsInfoModalOpen(true);
  };

  const closeInfoModal = () => {
    setIsInfoModalOpen(false);
  };

  return (
    <>
      <GrassHeaderFeature grassCount={grassCount} onInfoClick={openInfoModal} />
      <GrassInfoModal
        isOpen={isInfoModalOpen}
        onClose={closeInfoModal}
        isDesktop={isDesktop}
      />
    </>
  );
};

export default GrassHeader;
